import Cookies from 'js-cookie'

import coreUtils from 'common/src/utils/coreUtils'

const decodeTrackingCookie = (name) => {
  const value = Cookies.get(name)
  if (value === undefined || value === null) return undefined

  try {
    return decodeURI(value)
  } catch (e) {
    return value
  }
}

export const buildProfileJobReferrer = () => ({
  url: location.href,
  source: coreUtils.mobilecheck() ? 'mobile' : 'desktop',
  user_agent: coreUtils.userAgent(),
  app_version: coreUtils.urlInspector.getURLParameter('app_version') || 'modal',
  channel: coreUtils.urlInspector.getURLParameter('channel') || undefined,
  cta: (() => {
    const base = coreUtils.urlInspector.getURLParameter('cta') || 'profile'
    if (/_logged_(in|out)\z/.test(base)) return base

    const loggedIn = Boolean(window.App && window.App.currentUserId)
    return `${base}_${loggedIn ? 'logged_in' : 'logged_out'}`
  })(),
})

export const buildJobTrackingDataAttributes = () => ({
  creative: decodeTrackingCookie('creative'),
  keyword: decodeTrackingCookie('keyword'),
  matchtype: decodeTrackingCookie('matchtype'),
  adposition: decodeTrackingCookie('adposition'),
  campaignid: decodeTrackingCookie('campaignid'),
  adgroupid: decodeTrackingCookie('adgroupid'),
  geo: decodeTrackingCookie('geo'),
  utm_campaign: decodeTrackingCookie('utm_campaign'),
  utm_source: decodeTrackingCookie('utm_source'),
  utm_medium: decodeTrackingCookie('utm_medium'),
  utm_content: decodeTrackingCookie('utm_content'),
  gclid: decodeTrackingCookie('gclid'),
})

export const buildJobCreateIncluded = () => ([
  { type: 'alliance-partners', attributes: { name: 'ServiceSeeking' } },
  { type: 'job-referrers', attributes: buildProfileJobReferrer() },
  { type: 'tracking-data', attributes: buildJobTrackingDataAttributes() },
])
